import ServiceConfig from "@/views/configs/service/index.vue";

export default [
  {
    path: "servicos",
    name: "Serviços",
    component: ServiceConfig,
  },
];
